<template>
  <div>
    <img
        :src="require(`../../../assets/images/want-more@2x.png`)"
        :srcset="`${require(`../../../assets/images/want-more@1x.png`)} 1x, ${require(`../../../assets/images/want-more@2x.png`)} 2x, ${require(`../../../assets/images/want-more@3x.png`)} 3x, ${require(`../../../assets/images/want-more@4x.png`)} 4x`"
    />

    <div class="modal-body">
      <h2>{{ translate('Image Creation Queue Full') }}</h2>
      <p>{{ translate('You\'ve hit our concurrent image creation limit.') }}</p>
      <p class="font-weight-bold">{{ translate("Please wait for some to finish before creating more.") }}</p>
      <p class="font-weight-bold">{{ translate("Thanks for your patience!") }}</p>
    </div>
  </div>
</template>
<script>
import store from '../../../mixins/store.mixin';

export default {
  name: 'MaxConcurrentLimit',
  props: {},
  components: {},
  mixins: [store],
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>
